export default __webpack_public_path__ + "static/budget-book-7b7d9f88037c3a7d1d9e88049908ef32.png";